export const getCustRatingDialogueProps = ({
  t,
  message,
  dialogue
}) => {
  const translationKey = `${message.custScoreScheme.name}-${dialogue.body}`;
  const body = t(translationKey);
  const m = {
    ...message,
    customerScore: Number(dialogue.body)
  };
  return {
    ratingMessage: m,
    body,
    translationKey
  };
};